import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dp10-table-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      class="manage-user-button dp-secondary-btn"
      (click)="onCellClick(rowData)"
      [disabled]="rowData.isDisabled"
    >
      {{ label }}
    </button>
  `,
  styles: [
    `
      .manage-user-button {
        width: 108px;
        height: 34px;
        // right: 35%;
        left: 20%;
        position: relative;
      }
      .manage-user-button:disabled {
        background: var(--bg-overlay) !important;
        color: var(--bg-primary) !important;
        border-radius: 4px !important;
        border: none;
        font-size: 16px;
        font-weight: 600;
        font-family: var(--manrope) !important;
      }
    `,
  ],
})
export class Dp10CellComponent {
  @Input() label: string = 'Assign';
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  onCellClick(rowData: any) {
    this.cellClick.emit(rowData);
  }
}
